import React, { Fragment } from 'react';
import { TTMenu } from '../../../../interfaces/menus';
import { getFullImageUrl, isMenuAvailable } from '../../../utils';
import store from '../../../../store';
import { Transition } from '@headlessui/react';

type Props = {
  menu: TTMenu;
  onClick: () => void;
  card_width?: string;
};

const MenuCard: React.FC<Props> = ({ menu, onClick, card_width }) => {
  return (
    <Transition
      appear
      show={true}
      as={Fragment}
      enter="transform transition ease-in-out duration-500 sm:duration-700"
      enterFrom="translate-y-full"
      enterTo="translate-y-0"
      leave="transform transition ease-in-out duration-500 sm:duration-700"
      leaveFrom="translate-y-0"
      leaveTo="translate-y-full"
    >
      <div
        className={`relative ${
          isMenuAvailable(menu.hours ?? [])
            ? 'bg-surface'
            : 'bg-surface/400 rounded-lg'
        } hover:-translate-y-1 duration-300`}
      >
        {isMenuAvailable(menu.hours ?? []) ? (
          <></>
        ) : (
          <div className="absolute z-10 rounded-md px-2 top-1 right-1 bg-gray-900 text-white">
            Offline
          </div>
        )}
        <div
          key={menu.id}
          onClick={onClick}
          className="rounded-lg shadow-md cursor-pointer"
        >
          <div
            className={`relative group ${
              card_width && 'w-40 md:w-32 lg:w-40 2xl:w-44'
            }`}
          >
            <div className="group block w-full  aspect-w-14 aspect-h-14 rounded-t-lg  overflow-hidden">
              <img
                src={
                  menu.image_url !== null
                    ? getFullImageUrl(
                        menu.is_shared
                          ? menu.restaurant_id
                          : store.getState().restaurant.profile.restaurant_id,
                        `${menu.image_url}`,
                      )
                    : getFullImageUrl(
                        store.getState().restaurant.profile.restaurant_id,
                        `${
                          store.getState().restaurant.profile.main_profile_image
                        }`,
                      )
                }
                alt=""
                className={`object-cover pointer-events-none group-hover:brightness-105 ${
                  isMenuAvailable(menu.hours ?? []) ? '' : 'grayscale-50'
                }`}
              />
            </div>
            <div className="bg-primary/10 group-hover:brightness-110 rounded-b-lg">
              <div className="mx-2 mb-0 py-2 block text-md font-semibold text-on-surface pointer-events-none">
                <p className="line-clamp-2 ">{menu.name}</p>
              </div>
              <div className="block mx-2 text-md text-on-surface pointer-events-none ">
                <p className="line-clamp-3">{menu.description ?? ''}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  );
};

export default MenuCard;
